module.exports = __webpack_public_path__ + "static/assets/25cd84444a3e9a27f12831da2d937261.svg";